// src/utils/auth.js
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getUserInfo } from "../localStorage";

// Custom hook for admin authentication
export const useAdminAuth = () => {
    const navigate = useNavigate();
    const { adminId } = getUserInfo();

    useEffect(() => {
        if (adminId !== "isCurrentAdmin") {
            navigate("/", { replace: true });
        }
    }, [adminId, navigate]);

    return adminId === "isCurrentAdmin"; // optional if you want to use in component
};
